import { fetchGasLimit } from '../gas-estimation.js'

const getFeeInfo = async function getFeeInfo({
  assetClientInterface,
  asset,
  fromAddress,
  toAddress,
  amount,
  txInput,
  feeOpts = {},
}) {
  const { gasPrice: gasPrice_, tipGasPrice: tipGasPrice_ } = await assetClientInterface.getFeeData({
    assetName: asset.name,
  })

  let { gasLimit, gasPrice = gasPrice_, tipGasPrice = tipGasPrice_ } = feeOpts

  if (!gasLimit) {
    gasLimit = await fetchGasLimit({
      asset,
      fromAddress,
      toAddress,
      amount,
      txInput,
      throwOnError: false,
    })
  }

  return { gasPrice, gasLimit, tipGasPrice }
}

export default getFeeInfo
